export default __webpack_public_path__ + "static/media/permeable-blog-1.c6711b6c.jpg";